/**
 * @generated SignedSource<<65eadca36ed4c6e8ff5d8531f467f443>>
 * @relayHash ed2357135971fe9156669685e22ee2ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 647cc9989a1954034fe7d3f4e274b08ff2208b449dda2bcaaa87ba5aaf0295de

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SolutionComposerDataProviderQuery } from './SolutionComposerDataProviderQuery.graphql';

const node: PreloadableConcreteRequest<SolutionComposerDataProviderQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "647cc9989a1954034fe7d3f4e274b08ff2208b449dda2bcaaa87ba5aaf0295de",
    "metadata": {},
    "name": "SolutionComposerDataProviderQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
